__webpack_require__.p = "/rejestracja/";